<div class="position-relative d-flex flex-column h-100  text-grey" 
  cdkDrag cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary="body"
  [cdkDragDisabled]="!toogleDialog">
  <div class="modal-header p-3" cdkDragHandle>
    <h4 class="modal-title synchpc-primary" id="modal-title">Monitor Graph</h4>
    <i style="z-index: 9999; margin-right: 1rem"
       class="bi bi-arrows-fullscreen text-danger"
       [ngClass]="{
        'bi-arrows-fullscreen': !toogleFullScreen,
        'bi-fullscreen-exit': toogleFullScreen
      }"
       [title]="toogleFullScreen ? 'Exit full screen' : 'Full screen'"
       color="warn"
       (click)="onFullScreen()"></i>
    <i style="z-index: 9999; margin-right: 1rem"
       class="bi bi-dash text-danger"
       [ngClass]="{
        'bi-dash-lg': !toogleDialog,
        'bi-fullscreen': toogleDialog,
        'minmax-dialog': toogleDialog
      }"
       color="warn"
       (click)="toogleDialogMinMax()"
       [title]="toogleDialog ? 'Maximize' : 'Minimize'"></i>
    <i style="z-index: 9999"
       class="bi bi-x-lg text-danger"
       color="warn"
       (click)="onCancel()"
       title="Close"></i>
  </div>
  <div class="modal-body p-3">
    <div class="flex">
      <div class="flex-item">
        <div style="display: block;">
          <canvas baseChart
                  [data]="lineChartData"
                  [options]="lineChartOptions"
                  [type]="lineChartType"></canvas>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()" cdkFocusInitial>Close</button>
  </div>
</div>
